const toSnakeCase = (obj) => {
  return Object.entries(obj).reduce((newObj, [key, value]) => {
    const snakeKey = key.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
    return { ...newObj, [snakeKey]: value };
  }, {});
};

export default toSnakeCase;
